export const NavIcon = ({iconColor}) => {
  return (
    <svg width="37" height="26" viewBox="0 0 37 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M33.8716 2.17969H2.20017" 
        stroke={iconColor} 
        strokeWidth="4.31111" 
        strokeLinecap="round"/>
      <path 
        d="M33.8716 12.7363H18.0359" 
        stroke={iconColor}  
        strokeWidth="4.31111" 
        strokeLinecap="round"/>
      <path 
        d="M33.8716 23.2939H8.53445" 
        stroke={iconColor} 
        strokeWidth="4.31111" 
        strokeLinecap="round"/>
    </svg>
  )
}